import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const SuppliersListPage = lazy(() => import('src/pages/suppliers/list'));
const SuppliersPerformancePage = lazy(() => import('src/pages/suppliers/performance'));
const SupplierDetailPage = lazy(() => import('src/pages/suppliers/performanceDetail'));
const CreateSupplierPage = lazy(() => import('src/pages/suppliers/createSupplier'));
const EditSupplierPage = lazy(() => import('src/pages/suppliers/editSupplier'));

export const suppliersRoutes = [
  {
    path: 'suppliers',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <Navigate to="list" replace />, index: true },
      { path: 'list', element: <SuppliersListPage /> },
      { path: 'performance', element: <SuppliersPerformancePage /> },
      { path: 'performance/:supplierId', element: <SupplierDetailPage /> },
      { path: 'new', element: <CreateSupplierPage /> },
      { path: 'edit/:id', element: <EditSupplierPage /> },
    ],
  },
];
